var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHLetter = function SvgHLetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 122 136"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h-letter_svg__a)",
    d: "M107.069 0c9.927 0 14.895 4.963 14.895 14.88V136h-19.342c-9.927 0-14.895-4.963-14.895-14.88V84.556h-53.76V136H14.805C4.88 136-.06 131.037.001 121.12V0h19.071C29 0 33.967 4.963 33.967 14.88v39.736h53.76V0z",
    className: "h-letter_svg__Vector"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "h-letter_svg__a",
    x1: -21.616,
    x2: 948.139,
    y1: 56.908,
    y2: 187.463,
    className: "h-letter_svg__a",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#983EBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213DB5"
  })))));
};
export default SvgHLetter;